import { LocaleLink } from "@/components/LocaleLink";
import { useLocale } from "@/lib/i18n";
import mushroomImg from "@/assets/farve/coll-mushroom.jpg";

/**
 * Hero — single bold brand statement against the four-mushroom photograph.
 * One CTA. No strip. No swatch row. Maximum contrast.
 */
export function HeroMushroom() {
  const locale = useLocale();

  const eyebrow = locale === "da" ? "Et kurateret vintage-univers" : "A curated vintage universe";
  const head = locale === "da" ? "Gamle fund." : "Old finds.";
  const headItalic = locale === "da" ? "Nye hjem." : "New homes.";
  const cta = locale === "da" ? "Se udvalget" : "See the selection";

  return (
    <section className="relative isolate min-h-[88svh] overflow-hidden bg-[oklch(0.96_0.01_85)] md:min-h-[100svh]">
      <div className="absolute inset-0">
        <img
          src={mushroomImg}
          alt="Fire vintage Murano mushroom-lamper i lyserød, hvid, gul og lyseblå"
          className="h-full w-full animate-ken-burns object-cover"
          fetchPriority="high"
          decoding="async"
        />
        {/* Stronger left wash for contrast */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(100deg, oklch(0.20 0.01 85 / 0.55) 0%, oklch(0.20 0.01 85 / 0.30) 35%, transparent 65%)",
          }}
          aria-hidden
        />
        <div
          className="pointer-events-none absolute inset-x-0 top-0 h-40 md:h-48"
          style={{
            background:
              "linear-gradient(180deg, oklch(0.20 0.01 85 / 0.55) 0%, transparent 100%)",
          }}
          aria-hidden
        />
      </div>

      <div className="relative mx-auto flex min-h-[88svh] max-w-[1500px] flex-col justify-end px-6 pb-24 pt-28 md:min-h-[100svh] md:px-10 md:pb-32 md:pt-40">
        <div className="max-w-3xl animate-hero-rise">
          <p className="text-[10px] uppercase tracking-[0.32em] text-background/85">
            {eyebrow}
          </p>

          <h1 className="mt-6 font-display text-[clamp(2.8rem,9vw,8rem)] font-light leading-[0.92] tracking-tight text-background">
            {head}{" "}
            <span className="display-italic text-[oklch(0.93_0.09_95)]">{headItalic}</span>
          </h1>

          <div className="mt-8 h-px w-16 bg-background/40" aria-hidden />

          <div className="mt-10">
            <LocaleLink
              to="/collections/$handle"
              params={{ handle: "murano-loftlamper" }}
              className="group inline-flex items-center gap-3 rounded-full bg-background px-9 py-5 text-[11px] font-medium uppercase tracking-[0.26em] text-foreground transition-all hover:bg-terracotta hover:text-background"
            >
              {cta}
              <span className="transition-transform group-hover:translate-x-1">→</span>
            </LocaleLink>
          </div>
        </div>
      </div>
    </section>
  );
}
